( function NewsletterPopup( $ ) {

    document.body.addEventListener( 'click', ( event ) => {

        if( event.target.closest( '[data-js-newsletter-trigger]' ) ||
            ! event.target.closest( '[data-js-newsletter-popup]' ) &&
            ! document.querySelector( '[data-js-newsletter-popup="hidden"]' )
        ) {

            togglePopup( event );

        }

    } );

    /**
     * Toggle Popup
     */
    const togglePopup = ( event ) => {

        event.preventDefault();

        let $popup = document.querySelector( '[data-js-newsletter-popup]' );
        let state = $popup.getAttribute( 'data-js-newsletter-popup' ) === 'hidden' ? 'showing' : 'hidden';

        $popup.setAttribute( 'data-js-newsletter-popup', state );

    };

} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/newsletter-popup.js